import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { DataSourceDataDocument } from '~/pages/data-sources/queries/data.generated';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDataItemDocument } from './create.generated';

export const useCreateDataItem = (options: ApiOptions<typeof CreateDataItemDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(CreateDataItemDocument, {
    ...useNotifications(CreateDataItemDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.data_items.create_success'),
    }),
    refetchQueries: [DataSourceDataDocument],
    ...options,
  });
};
